import { PortfolioRepo } from "../../portfolio/portfolio.repo";
import { ClientRepo } from "../../clients/client.repo";

class NewPortfolioController {
  public clientNumber: number;
  public portfolio: any;
  selectedItem: any;
  searchText: string;
  public accountNumbers: any;
  public tradeAccounts: any;

  public newPortfolio: boolean;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private clientRepo: ClientRepo,
    private portfolioRepo: PortfolioRepo,
    private $stateParams: angular.ui.IStateParamsService
  ) {}

  $onInit() {
    this.clientNumber = +this.$stateParams["id"];
    if (this.portfolio.name.length > 0) {
      this.newPortfolio = false;
    } else {
      this.newPortfolio = true;
    }
    this.getAccounts().then((accounts) => {
      let accountList = accounts as Array<any>;
      this.accountNumbers = accountList.filter((acc) => acc.source != "CDS");
      this.tradeAccounts = accountList.filter((acc) => acc.source == "CDS");
    });
  }

  querySearch(searchText: string) {
    return this.clientRepo
      .filterAccounts(searchText, this.clientNumber)
      .then((result) => result.data);
  }
  getAccounts() {
    return this.clientRepo
      .filterAccounts(" ", this.clientNumber)
      .then((result) => result.data);
  }

  addAccount() {
    if (!this.selectedItem) {
      return;
    }

    if (
      !this.portfolio.accounts.find(
        (account) => account.id === this.selectedItem.id
      )
    ) {
      this.portfolio.accounts.push(this.selectedItem);
    }
    this.selectedItem = undefined;
  }
  removeAccount(accountId: number) {
    let accountToRemove = this.portfolio.accounts.findIndex(
      (account) => account.id === accountId
    );
    this.portfolio.accounts.splice(accountToRemove, 1);
  }

  removeTradeAccount() {
    let that = this;
    that.portfolio.tradeAccount = null;
  }

  savePortfolio() {
    this.portfolioRepo
      .savePortfolio(this.portfolio, this.clientNumber)
      .then((result) => {
        this.portfolio.portfolioId = result.data;
        this.$mdDialog.hide(this.portfolio);
      });
  }

  cancel() {
    this.$mdDialog.hide();
  }
}
export const newPortfolioModal: angular.IComponentOptions = {
  template: require("./newportfolio.modal.html"),
  controller: NewPortfolioController,
  bindings: {
    portfolio: "<",
    clientNumber: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/newportfolio.modal.ts